import { connect } from 'react-redux';
import { EXCHANGE_TYPEAHEAD_CLEAR, EXCHANGE_DATEPICKER_CHANGE } from 'constants/ActionTypes';
import {
  cancelTicket,
  getCancelledTicketStatusPoll,
  errorTripExchange,
  validateExchange,
  rescheduleTicket,
} from '../../../actions/exchange';
import { validateChangeDocument, changeDocument } from '../../../actions/purchase';
import { dasherize } from '../../../utils/Helpers';

import ExchangeTicketList from './ExchangeTicketList';

const mapStateToProps = ({ purchase, exchange, code }) => {
  const { passengers, allPassengers, selectedPassengerToAlter } = exchange;

  const { purchaseToken, idCancellation, cancelStatus } = exchange;
  const { trip, showCancelModal, hasConnections, hasConnectionsReturns } = exchange;
  const { tripDepart, tripReturn, tripDepartConnection, tripReturnConnection } = exchange.trips;
  const { origin, destination, departCancelAllowed, returnCancelAllowed, isPix } = exchange.ticket;

  const currentTicket = exchange.ticket.operationNumber;

  // Normalize to ensure spaces are converted to dashes for SearchWidget and URL consistency
  const normalizedOrigin = dasherize(origin);
  const normalizedDestination = dasherize(destination);

  const { errorTrip } = exchange;
  return {
    isFetching: purchase.get('isFetching'),
    token: purchase.get('token'),
    currentTicket,
    code,
    errorTrip,
    passengers,
    allPassengers,
    hasConnections,
    hasConnectionsReturns,
    selectedPassengerToAlter,
    trip,
    tripReturn,
    origin: normalizedOrigin,
    destination: normalizedDestination,
    tripDepart,
    purchaseToken,
    idCancellation,
    cancelStatus,
    showCancelModal,
    tripDepartConnection,
    tripReturnConnection,
    departCancelAllowed,
    returnCancelAllowed,
    isPix,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setDate: (date) => dispatch({ type: EXCHANGE_DATEPICKER_CHANGE, date }),
    clearTypeahead: (origin, destination) =>
      dispatch({
        type: EXCHANGE_TYPEAHEAD_CLEAR,
        origin,
        destination,
      }),
    errorTripExchange: (errorTrip) => dispatch(errorTripExchange(errorTrip)),
    cancelTicket: (purchaseToken, seat) => dispatch(cancelTicket(purchaseToken, seat)),
    getCancelledTicketStatusPoll: (purchaseToken, idCancellation) =>
      dispatch(getCancelledTicketStatusPoll(purchaseToken, idCancellation)),
    validateExchange: (
      history,
      operationNumbers,
      NIT,
      origin,
      destination,
      recaptchaToken,
      email,
      document,
    ) =>
      dispatch(
        validateExchange(
          history,
          operationNumbers,
          NIT,
          origin,
          destination,
          recaptchaToken,
          email,
          document,
        ),
      ),
    rescheduleTicket: (ticket) => dispatch(rescheduleTicket(ticket)),
    validateChangeDocument: (params) => dispatch(validateChangeDocument(params)),
    changeDocument: (params) => dispatch(changeDocument(params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeTicketList);
